import React, { FunctionComponent } from 'react';
import { FunnelType } from 'scenes/common/flows/types';
import { HomeFunnelState } from 'scenes/home/types';
import { QuotePriceExcessInfo } from 'scenes/common/components/QuotePriceExcessInfo';

import {
  isBuildingAndContentsCoverType,
  isBuildingCoverType,
  isContentsCoverType,
  getSelectedBuildingExcess,
  getSelectedContentsExcess,
} from 'scenes/home/selectors';

const QuotePriceExcess: FunctionComponent<{ funnelState: HomeFunnelState }> = ({
  funnelState,
}) => {
  const { amount: buildingExcess } = getSelectedBuildingExcess(funnelState);
  const { amount: contentsExcess } = getSelectedContentsExcess(funnelState);
  const isBuildingAndContentsCover = isBuildingAndContentsCoverType(
    funnelState
  );
  const isBuildingCover = isBuildingCoverType(funnelState);
  const isContentsCover = isContentsCoverType(funnelState);
  const excess = isBuildingCover ? buildingExcess : contentsExcess;
  return (
    <>
      <QuotePriceExcessInfo
        funnelType={FunnelType.Home}
        isBuildingAndContentsCover={isBuildingAndContentsCover}
        isBuildingCover={isBuildingCover}
        isContentsCover={isContentsCover}
        buildingExcess={buildingExcess}
        contentsExcess={contentsExcess}
        excess={excess}
      />
    </>
  );
};

export { QuotePriceExcess };
